export default __webpack_public_path__ + "static/media/trailer.29d4f032.svg";